<template>
  <form @submit.prevent="handleFormSubmit()" class="animate__animated animate__fadeIn animate__delay-50s">
    <wyse-input-group
      type="text"
      :error="errors.firstName || errors.lastName"
      label="Name"
      placeholderOne="First"
      placeholderTwo="Last"
      :value-one="formData.firstName"
      :value-two="formData.lastName"
      @valueOne="formData.firstName = $event"
      @valueTwo="formData.lastName = $event"
      required
    />
    <wyse-input
      type="email"
      :error="errors.email"
      label="Email"
      v-model="formData.email"
      required
    />
    <wyse-input
      type="tel"
      :error="errors.phone"
      label="Phone"
      v-model="formData.phone"
      required
    />

    <tips-text v-if="!showMessage">
      Would you like to <a @click="showMessage = true">add a message</a> with your tour request?
    </tips-text>
    <transition name="fade">
      <wyse-textarea
        v-if="showMessage"
        label="Message"
        :error="errors.message"
        v-model="formData.message"
      />
    </transition>

    <wyse-base-button type="submit" :disabled="loading" clas>
      <spinner v-if="loading" :size="20" :borderWidth="3" />
      <template v-else>Schedule Tour</template>
    </wyse-base-button>
  </form>
</template>

<script>
import WyseInputGroup from "../components/form/WyseInputGroup";
import WyseInput from "../components/form/WyseInput";
import WyseTextarea from "../components/form/WyseTextarea";
import { getDateStringFromDate } from "../utils";
import Spinner from "./Spinner.vue";
import TipsText from "./TipsText.vue";
import WyseBaseButton from "./WyseBaseButton.vue";

export default {
  name: "ScheduleForm",
  components: {
    WyseBaseButton,
    WyseInput,
    WyseTextarea,
    Spinner,
    TipsText,
    WyseInputGroup
  },
  inject: ["formHandler"],
  data() {
    return {
      loading: false,
      showMessage: false,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      },
      errors: {
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        message: false,
      },
    };
  },
  methods: {
    handleFormSubmit() {
      Object.keys(this.formData).forEach((k) => {
        if (k !== "message") this.errors[k] = !this.formData[k];
      });
      let isValid = Object.values(this.errors).every((v) => !v);
      console.log(this.formData);
      console.log({ isValid });
      if (isValid) {
        this.loading = true;
        this.formHandler
          .scheduleTour(
            this.formData.firstName,
            this.formData.lastName,
            this.formData.email,
            this.formData.phone,
            this.formData.message,
            getDateStringFromDate(this.$store.state.formData.tourDate),
            this.$store.state.formData.tourTime,
            this.$store.state.formData.desiredBedroom
          )
          .then(() => {
            // TODO: Navigate to success page
            this.$router.push("/schedule-success");
          })
          .catch(() => {
            this.$router.push("/submission-error");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wyse-base-button {
  margin-top: 25px;
  width: calc(100% - 60px);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
}
</style>
